import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./TestimonialsSection.module.css";

const TestimonialGallery = ({ compact = false }) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const images = [
    { src: "/images/temoignage1.webp", alt: t("TestimonialImageAlt", { num: 1 }), href: "https://upreality.store/p/CaffeCardito" },
    { src: "/images/temoignage2.webp", alt: t("TestimonialImageAlt", { num: 2 }), href: "https://upreality.store/p/NonnaCardito" },
    { src: "/images/temoignage3.webp", alt: t("TestimonialImageAlt", { num: 3 }), href: "https://upreality.store/p/CaffeCardito" },
  ];

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > 50 && currentIndex < images.length - 1) setCurrentIndex(currentIndex + 1);
    if (distance < -50 && currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const goToPrevious = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const goToNext = () => {
    if (currentIndex < images.length - 1) setCurrentIndex(currentIndex + 1);
  };

  const current = images[currentIndex];
  const imageEl = (
    <img
      src={current.src}
      alt={current.alt}
      className={`${styles.galleryImage}${compact ? ` ${styles.galleryImageCompact}` : ""}`}
    />
  );

  return (
    <div className={`${styles.gallery}${compact ? ` ${styles.galleryCompact}` : ""}`}>
      <div
        className={styles.galleryImageWrap}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {current.href ? (
          <a href={current.href} target="_blank" rel="noopener noreferrer" style={{ display: "block" }}>
            {imageEl}
          </a>
        ) : (
          imageEl
        )}
      </div>

      <button
        type="button"
        className={`${styles.galleryNav} ${styles.galleryNavPrev}`}
        onClick={goToPrevious}
        aria-label={t("Previous")}
        disabled={currentIndex === 0}
      >
        <span aria-hidden="true">‹</span>
      </button>
      <button
        type="button"
        className={`${styles.galleryNav} ${styles.galleryNavNext}`}
        onClick={goToNext}
        aria-label={t("Next")}
        disabled={currentIndex === images.length - 1}
      >
        <span aria-hidden="true">›</span>
      </button>

      <div className={styles.galleryDots}>
        {images.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`${styles.galleryDot}${index === currentIndex ? ` ${styles.galleryDotActive}` : ""}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={t("TestimonialImageAlt", { num: index + 1 })}
            aria-current={index === currentIndex ? "true" : undefined}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialGallery;
